// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Szűrő kártya */
.filter-form {
  background: linear-gradient(135deg, #f9fbff 0%, #f4f6fb 100%);
  padding: 1.25rem 1rem;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, opacity 0.3s ease;
  margin: 8px 0 4px;
}

.filter-form .form-label {
  font-weight: 600;
  color: #394150;
}

.filter-form input[type=date],
.filter-form input[type=text] {
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

@media (max-width: 767.98px) {
  .d-none + .filter-form {
    transform: translateY(-10px);
    opacity: 0;
  }
  .filter-form {
    transform: translateY(0);
    opacity: 1;
  }
  .filter-form .form-label {
    font-size: 0.875rem;
  }
  .filter-form input[type=date],
  .filter-form input[type=text] {
    font-size: 0.875rem;
    padding: 0.45rem 0.5rem;
  }
  .filter-form button[type=submit] {
    font-size: 0.9rem;
    padding: 0.5rem 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./projects/public/src/app/components/event-filter/event-filter.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,iBAAA;AACA;EACE,6DAAA;EACA,qBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2CAAA;EACA,kDAAA;EACA,iBAAA;AAEF;;AACA;EACE,gBAAA;EACA,cAAA;AAEF;;AACA;;EAEE,mBAAA;EACA,qCAAA;AAEF;;AACA;EACE;IACE,4BAAA;IACA,UAAA;EAEF;EACA;IACE,wBAAA;IACA,UAAA;EACF;EAEA;IACE,mBAAA;EAAF;EAGA;;IAEE,mBAAA;IACA,uBAAA;EADF;EAIA;IACE,iBAAA;IACA,uBAAA;EAFF;AACF","sourcesContent":["/* Szűrő kártya */\n.filter-form {\n  background: linear-gradient(135deg, #f9fbff 0%, #f4f6fb 100%);\n  padding: 1.25rem 1rem;\n  border-radius: 12px;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.05);\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  margin: 8px 0 4px;\n}\n\n.filter-form .form-label {\n  font-weight: 600;\n  color: #394150;\n}\n\n.filter-form input[type='date'],\n.filter-form input[type='text'] {\n  border-radius: 10px;\n  border: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n@media (max-width: 767.98px) {\n  .d-none + .filter-form {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n\n  .filter-form {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  .filter-form .form-label {\n    font-size: 0.875rem;\n  }\n\n  .filter-form input[type='date'],\n  .filter-form input[type='text'] {\n    font-size: 0.875rem;\n    padding: 0.45rem 0.5rem;\n  }\n\n  .filter-form button[type='submit'] {\n    font-size: 0.9rem;\n    padding: 0.5rem 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
